import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';
import listenMiddleware from '../middlewares/listen';
import { scrollPositionMiddleware } from '../middlewares/scrollPosition';
import rootReducer from '../reducers';
import defaultRootSaga from '../sagas';
import createEventEmitter from './createEventEmitter';
import createFigmaEventEmitter from './createFigmaEventEmitter';
import createStoreListener from './createStoreListener';
export default function configureStore(initialState, listeners, isDownloaded, isAppBuild, rootSaga) {
    if (listeners === void 0) { listeners = {}; }
    if (isDownloaded === void 0) { isDownloaded = false; }
    if (isAppBuild === void 0) { isAppBuild = false; }
    if (rootSaga === void 0) { rootSaga = defaultRootSaga; }
    var sagaMiddleware = createSagaMiddleware();
    // const logger = store => next => action => {
    //   console.log('current state', store.getState());
    //   console.log('dispatching', action);
    //   let result = next(action);
    //   console.log('next state', store.getState());
    //   return result;
    // };
    var enhancers = applyMiddleware(thunkMiddleware, sagaMiddleware, 
    // logger,
    listenMiddleware(createStoreListener(listeners)), listenMiddleware(createEventEmitter(listeners)), listenMiddleware(createFigmaEventEmitter(listeners)), scrollPositionMiddleware);
    if (process.env.NODE_ENV === 'development' && !process.env.NO_DEV_TOOLS) {
        if (window.__REDUX_DEVTOOLS_EXTENSION__) {
            var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
            enhancers = composeEnhancers(enhancers);
        }
        else {
            // eslint-disable-next-line global-require
            var DevTools = require('../containers/DevTools').default;
            enhancers = compose(enhancers, DevTools.instrument());
        }
    }
    var store = createStore(rootReducer, initialState, enhancers);
    // Run the saga
    sagaMiddleware
        .run(rootSaga, store.dispatch, isAppBuild, isDownloaded)
        .done.catch(function (err) {
        // eslint-disable-next-line no-console
        console.error(err);
    });
    // Enable Webpack hot module replacement for reducers
    if (module.hot && process.env.NODE_ENV === 'development') {
        module.hot.accept('../reducers', function () {
            // eslint-disable-next-line global-require
            var nextReducer = require('../reducers').default;
            store.replaceReducer(nextReducer);
        });
    }
    return store;
}
